import { defineStore } from 'pinia';
import { useAuthStore, useUtilsStore } from "@/store";

export const useVerifyStore = defineStore({
    id: 'verify',
    state: () => ({
        
    }),
    actions: {
        async verifyAccount() {
          let raw = {
              "RequestID": "",
              "DeviceDetail": useUtilsStore().getDeviceDetail(),
              "ClientIP": "",
              "ServiceID": useAuthStore().serviceId,
              "AccountName": useAuthStore().userInfoMyVTC.AccountName  || "",
              "AccessToken": useAuthStore().userInfoMyVTC.AccessToken  || "",
              "RelateAccount": useAuthStore().relateAccount,
              "Type": useAuthStore().action
          }
          const response = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_SSO_URL}v1.0/AccountVerify`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(raw),
          }).then((res) => {
              return res.json();
          });
          return response;
      }
    }
});